// /src/layouts/admin/Header.js
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logoutLocal } from '../../auth/authSlice';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutLocal());
    navigate('/login');
  };

  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left Navbar */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <a href="/" className="nav-link">Home</a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <a href="/contact" className="nav-link">Contact</a>
          </li>
        </ul>

        {/* Right Navbar */}
        <ul className="navbar-nav ml-auto">
          {/* Fullscreen */}
          <li className="nav-item">
            <a className="nav-link" data-widget="fullscreen" href="#" role="button">
              <i className="fas fa-expand-arrows-alt" />
            </a>
          </li>

          {/* Control Sidebar */}
          <li className="nav-item">
            <a className="nav-link" data-widget="control-sidebar" data-controlsidebar-slide="true" href="#" role="button">
              <i className="fas fa-th-large" />
            </a>
          </li>

          {/* User Dropdown */}
          <li className="nav-item dropdown user-menu">
            <a href="#" className="nav-link dropdown-toggle" data-toggle="dropdown">
              <img src="/images/user.png" className="user-image img-circle elevation-2" alt="User" />
              <span className="d-none d-md-inline">{user?.name || 'User'}</span>
            </a>
            <ul className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              {/* User image */}
              <li className="user-header bg-primary">
                <img src="/images/user.png" className="img-circle elevation-2" alt="User" />
                <p>
                  {user?.name || 'User'}
                  <small>Role: {user?.role || 'N/A'}</small>
                </p>
              </li>
              {/* Footer */}
              <li className="user-footer">
                <a href="/profile" className="btn btn-default btn-flat">Profile</a>
                <button onClick={handleLogout} className="btn btn-default btn-flat float-right">
                  Sign out
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Header;
